import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-varsha',
  templateUrl: './varsha.component.html',
  styleUrls: ['./varsha.component.scss']
})
export class VarshaComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getVarsha();
  }

}
